// Analytics is intentionally disabled for the internal OpenRewi deployment.
// Keep a no-op API so upstream UI instrumentation remains harmless.
const noop = () => {}

const posthog = {
  capture: noop,
  identify: noop,
  reset: noop,
  get_distinct_id: () => null,
  isFeatureEnabled: () => false,
  getFeatureFlag: () => null,
  onFeatureFlags: noop,
  setPersonPropertiesForFlags: noop,
}

export default {
  install(Vue) {
    Vue.prototype.$posthog = posthog
  },
}
